import { GridColDef } from '@mui/x-data-grid-premium';
import { DataGridLinkCell, baseCell } from 'components/cells';
import { filterOperators } from 'components/enhanced';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useEquipmentAccessorColumns = (): GridColDef[] => {
  const translationPrefix = 'entities.accessor';
  const { t } = useTranslation();

  return useMemo<GridColDef[]>(
    () => [
      {
        field: 'code',
        headerName: t(`${translationPrefix}.code`),
        flex: 1,
        minWidth: 250,
        filterOperators,
        renderCell: (params) => (
          <DataGridLinkCell
            params={params}
            basePath="/tenant/equipments/accessories/"
            idKey="id"
            passDuplicateState
          />
        )
      },
      {
        field: 'description',
        headerName: t(`${translationPrefix}.description`),
        flex: 1,
        minWidth: 250,
        filterOperators,
        renderCell: baseCell
      },
      {
        field: 'serial_number',
        headerName: t(`${translationPrefix}.serial_number`),
        flex: 1,
        minWidth: 250,
        filterOperators,
        renderCell: baseCell
      }
    ],
    [t]
  );
};
